/** @format */

export const BID_SETTING = {
  SHOW_BIDDING: 'ShowBidding',
  DONT_SHOW_BIDDING: 'DontShowBidding',
  SHOW_HIGHEST_BID: 'ShowHighestBid',
  SHOW_BID_HISTORY: 'ShowBidHistory'
};
